import createApp from './app'

const app = createApp({ window })

app.$options.router.onReady(() => {
	app.$mount('#app', true)
})
